<template>
  <div class="view-tag">
    <ViewTag/>
  </div>
</template>

<script>
// @ is an alias to /src
import ViewTag from '@/components/ViewTag.vue'

export default {
  name: 'ViewTagPage',
  components: {
    ViewTag
  }
}
</script>
